var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mt-2 white--text",
          attrs: {
            app: "",
            color: _vm.savingsColor,
            extended: "",
            "extension-height": "20"
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c("v-flex", { staticClass: "font-italic" }, [
                _vm._v("Annual Savings")
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c("h1", [_vm._v(_vm._s(_vm._f("currency")(_vm.annualTotal)))])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("h4", [
            _vm._v(_vm._s(_vm._f("currency")(_vm.totalByHeads)) + " / head")
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { slot: "extension", row: "" }, slot: "extension" },
            [
              _c("v-flex", { staticClass: "font-italic" }, [
                _vm._v(
                  "Save " + _vm._s(_vm._f("currency")(_vm.slider)) + "/mile,"
                )
              ]),
              _vm._v(" "),
              _c("v-flex", { staticClass: "font-italic justify-end" }, [
                _vm._v(
                  _vm._s(_vm._f("currency")(_vm.effectiveRate)) +
                    "/mile adjusted rate"
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass: "pa-0",
          attrs: { "align-center": "", "text-xs-center": "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { column: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                { staticClass: "pr-1" },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Head Count",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.headsCount,
                                      callback: function($$v) {
                                        _vm.headsCount = _vm._n($$v)
                                      },
                                      expression: "headsCount"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.weightOptions,
                                      label: "Avg. Per-head Weight"
                                    },
                                    model: {
                                      value: _vm.weight,
                                      callback: function($$v) {
                                        _vm.weight = _vm._n($$v)
                                      },
                                      expression: "weight"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Avg. Distance in miles",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.distance,
                                      callback: function($$v) {
                                        _vm.distance = _vm._n($$v)
                                      },
                                      expression: "distance"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { staticClass: "pl-1" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.freqOptions,
                                      "item-text": "name",
                                      "item-value": "value",
                                      error: _vm.selectedFreq == null,
                                      label: _vm.frequencyLabel
                                    },
                                    model: {
                                      value: _vm.selectedFreq,
                                      callback: function($$v) {
                                        _vm.selectedFreq = $$v
                                      },
                                      expression: "selectedFreq"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.truckCapacityOptions,
                                      "item-text": "name",
                                      "item-value": "value",
                                      label: "Avg. Truck Capacity"
                                    },
                                    model: {
                                      value: _vm.truckCapacityPounds,
                                      callback: function($$v) {
                                        _vm.truckCapacityPounds = $$v
                                      },
                                      expression: "truckCapacityPounds"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Current Per-mile Rate",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.standardRate,
                                      callback: function($$v) {
                                        _vm.standardRate = _vm._n($$v)
                                      },
                                      expression: "standardRate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pt-2 pb-1", attrs: { xs12: "", md12: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic font-weight-thin" },
                              [_vm._v(_vm._s(_vm.truckCapacityAnimalCount))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic font-weight-thin" },
                              [_vm._v("animals per load")]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic font-weight-thin" },
                              [_vm._v(_vm._s(_vm.truckCount))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic font-weight-thin" },
                              [
                                _vm._v(
                                  "trucks (" +
                                    _vm._s(_vm.annualTruckCount) +
                                    " annually)"
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic green--text" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.slider * _vm.distance
                                    )
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", [
                            _c(
                              "h4",
                              { staticClass: "font-italic font-weight-thin" },
                              [_vm._v("per load freight savings")]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "mt-1", attrs: { xs12: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pb-2" },
                    [
                      _c("v-card-title", [
                        _c("h4", [
                          _vm._v(
                            "Does saving nickels matter to your bottom line?"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { "align-baseline": "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-slider", {
                                attrs: {
                                  step: 0.05,
                                  min: 0.05,
                                  max: 2,
                                  "always-dirty": "",
                                  "thumb-size": 24,
                                  "thumb-label": "always",
                                  thumbColor: _vm.savingsColor,
                                  "append-icon": "add",
                                  "prepend-icon": "remove"
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.slider = _vm.slider + 0.05
                                  },
                                  "click:prepend": function($event) {
                                    _vm.slider = _vm.slider - 0.05
                                  }
                                },
                                model: {
                                  value: _vm.slider,
                                  callback: function($$v) {
                                    _vm.slider = $$v
                                  },
                                  expression: "slider"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", [
                        _c("div", { staticClass: "pa-1 font-italic" }, [
                          _vm._v("\n              If you can save "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.sliderHint))
                          ]),
                          _vm._v(" per mile ...\n            ")
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pt-1 mt-1", attrs: { xs12: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                href: _vm.createActionLink
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "pr-2" }, [
                                _vm._v("message")
                              ]),
                              _vm._v(
                                "\n              Text " +
                                  _vm._s(_vm.$t("site-title.brief")) +
                                  " To Save Nickles\n            "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55897527", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55897527","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SavingsCalculator.vue
// module id = null
// module chunks = 